<template>
  <div>
    <div class="fe-text-heading-xxs lg:fe-text-heading-xs fe-mb-s lg:fe-mb-m">
      {{ titleText }}
    </div>
    <div class="fe-grid fe-grid-cols-3 fe-gap-xs lg:fe-gap-base">
      <div class="fe-col-span-1">
        <RatingStats />
      </div>
      <div class="fe-col-span-2">
        <RatingHistogram maxProgressBars="5" />
      </div>
    </div>
  </div>
</template>

<script>
  import RatingHistogram from "./RatingHistogram.vue"
  import RatingStats from "./RatingStats.vue"
  import { translate } from "@/utils/utils"
  import { TRANSLATION_KEYS } from "@/constants/translationKeys"

  export default {
    name: "RatingSummary",
    components: {
      RatingStats,
      RatingHistogram,
    },
    computed: {
      titleText() {
        return translate(TRANSLATION_KEYS.REVIEW_TITLE)
      },
    },
  }
</script>
